<section class="agpr-timePicker" *ngIf="selectedTimeSeries && localization" [ngClass]="styleClass">
    <div
        *ngFor="let timeData of selectedTimeSeries; let i = index; first as isFirst; last as isLast"
    >

        <fieldset class="agpr-multiTimePicker-fieldset">
            <legend [ngClass]="{ 'u-srOnly': isHiddenLabel }">
                {{ (header || 'multiTimeSelection') | localize }}
            </legend>
            <div class="agpr-multiTimePicker-time">
                <agpr-time-picker
                    class="agpr-multiTimePicker-timePicker"
                    [id]="id + '-' + i"
                    [showTimeZoneSelector]="false"
                    [hourDescribedBy]="hourDescribedBy"
                    [minuteDescribedBy]="minuteDescribedBy"
                    [ngModel]="selectedTimeSeries[i]"
                    (changeHour)="onModelChange(selectedTimeSeries)"
                    (changeMinute)="onModelChange(selectedTimeSeries)"
                    (changeMeridian)="onModelChange(selectedTimeSeries)"
                ></agpr-time-picker>

                <span class="agpr-multiTimePicker-seriesActionsButtons">
                    <agpr-button
                        *ngIf="isLast && i <= 10"
                        class="agpr-multiTimePicker-seriesActionsButton"
                        (click)="addSeries()"
                        ariaLabel="Common.input.addTime"
                        icon="fa-regular fa-duotone fa-plus"
                        [style]="buttonTypes.icon"
                    ></agpr-button>
                    <agpr-button
                        *ngIf="!(isLast && isFirst)"
                        class="agpr-multiTimePicker-seriesActionsButton"
                        (click)="removeSeries(i)"
                        ariaLabel="Common.input.removeTime"
                        icon="fa-regular fa-duotone fa-trash-can"
                        [style]="buttonTypes.icon"
                    ></agpr-button>
                </span>
            </div>

            <div *ngIf="showTimeZoneSelector && isLast" class="agpr-timePicker-timeZone ui-fluid">
                <agpr-timezone-picker
                    class='agpr-timePicker-timeZoneDropdown'
                    [id]="id + '-timezonePicker'"
                    [(ngModel)]="selectedTimeSeries[i].timeZone"
                    (ngModelChange)="timeZoneChanged($event, i)"
                    [disabled]="disabled"
                ></agpr-timezone-picker>
                <span
                    *ngIf="showTimezoneDisclaimer"
                    role="img"
                    class="fa-regular fa-circle-info"
                    [ngClass]="infoIconStyleClass"
                    [tooltipStyleClass]="infoTooltipStyleClass"
                    agprTooltip="Common.forms.timePicker.daylightSavingsDisclaimer"
                ></span>
            </div>
        </fieldset>

    </div>
</section>
